import { useNavigate } from 'react-router';

interface Props {
  title: string;
  onBack?: () => void;
}

export function Topbar({ title, onBack }: Props) {
  const nav = useNavigate();
  return (
    <header className="topbar">
      <button
        type="button"
        className="back"
        onClick={onBack ?? (() => nav(-1))}
        aria-label="Back"
      >
        ← BACK
      </button>
      <div className="title">{title}</div>
      <div style={{ width: 54 }} />
    </header>
  );
}
